import { Routes } from '@angular/router';

import { RegisterMovelGuard } from '../core/guards/register-movel.guard';
import { UtmPreserveGuard } from '../core/guards/utm-preserve.guard';
import { OnlyIndicationGuard } from '../core/guards/only-indication.guard';
import { HomeComponent } from '../pages/home/home.component';
import { ProductPagesComponent } from '../pages/product-pages/product-pages.component';
import { CampaignLandingComponent } from '../pages/campaign-landing/campaign-landing.component';
import { CategoryGuard } from '../core/guards/category.guard';
import { campaignLandingCanMatch } from '../core/campaign/campaign-landing.match';
import { NotFoundComponent } from '../pages/not-found/not-found.component';
import { CatalogComponent } from '../pages/catalog/catalog.component';
import { HelpCenterComponent } from '../pages/help-center/help-center.component';
import { SlugRedirectGuard } from '../core/guards/slug-redirect.guard';
import { SlugRedirectComponent } from '../pages/slug-redirect/slug-redirect.component';
import { RedirectCodeGuard } from '../core/guards/redirect-code.guard';
import { RedirectCodeComponent } from '../pages/redirect-code/redirect-code.component';
import { WebsummitContatoComponent } from '../pages/websummit-contato/websummit-contato.component';
import { OboticarioEmbedComponent } from '../pages/oboticario-embed/oboticario-embed.component';
import { FormularioParceiroComponent } from '../pages/formulario-parceiros/formulario-parceiros.component';

import { authRoutes } from './auth.routes';
import { myAccountRoutes } from './my-account.routes';
import { checkoutRoutes } from './checkout.routes';
import { partnerRoutes } from './partners.routes';
import { indicationRoutes } from './indication.routes';

export const routes: Routes = [
  {
    path: 'websummit-contato',
    component: WebsummitContatoComponent,
    pathMatch: 'full',
    canActivate: [OnlyIndicationGuard],
  },
  {
    path: 'agendeumavisita',
    component: FormularioParceiroComponent,
    pathMatch: 'full',
    canActivate: [OnlyIndicationGuard],
  },
  {
    path: 'grupoboticario',
    canActivate: [OnlyIndicationGuard],
    children: [
      { path: '', component: OboticarioEmbedComponent },
      { path: '**', component: OboticarioEmbedComponent },
    ],
  },
  {
    path: '',
    canActivateChild: [RegisterMovelGuard, UtmPreserveGuard, OnlyIndicationGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      ...authRoutes,
      ...myAccountRoutes,
      ...indicationRoutes,
      ...partnerRoutes,
      ...checkoutRoutes,
      {
        path: 'catalog/seller',
        component: CatalogComponent,
        pathMatch: 'full',
        data: { sellerMode: true },
      },
      { path: 'catalog', component: CatalogComponent, pathMatch: 'full' },
      { path: 'help-center', component: HelpCenterComponent },
      {
        path: 'r/:code',
        component: RedirectCodeComponent,
        canActivate: [RedirectCodeGuard],
        pathMatch: 'full',
      },
      { path: '404', component: NotFoundComponent },
      {
        path: 'empresas/:slug',
        component: SlugRedirectComponent,
        canActivate: [SlugRedirectGuard],
        pathMatch: 'full',
      },
      {
        path: 'colaboracao-e-produtividade/aplicativos-office',
        redirectTo: 'colaboracao-e-produtividade/microsoft-365',
        pathMatch: 'full',
      },
      {
        path: 'cloud/gpu-as-a-service',
        pathMatch: 'full',
        redirectTo: '/cloud/gpu-as-a-service/',
      },
      {
        path: 'colaboracao-e-produtividade',
        redirectTo: '/produtividade-e-gestao',
        pathMatch: 'full',
      },
      {
        path: 'gestao-e-beneficios-empresariais',
        redirectTo: '/produtividade-e-gestao',
        pathMatch: 'full',
      },
      {
        path: ':category/:productSlug',
        component: ProductPagesComponent,
        canActivate: [CategoryGuard],
        pathMatch: 'full',
      },
      {
        path: ':productSlug',
        canMatch: [campaignLandingCanMatch],
        data: { campaignLanding: true },
        component: CampaignLandingComponent,
        pathMatch: 'full',
      },
      {
        path: ':category',
        component: HomeComponent,
        canActivate: [CategoryGuard],
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: '/404',
      },
    ],
  },
];
